<template>
  <div class="Profile">
    <div class="content">
      <div style="filter:url(#displacementMap_profile)" @mouseenter="mouseOver" @mouseleave="mouseLeave" >
        <h1>Heriberto Rodriguez</h1>
        <p>
          Creative developer focused on solving problems with new technologies user centered design and strict scientific methods.
        </p>
        <p>
          A physicist and mathematician who learned how to code, improve the user experience and interaction design.
        </p>
        <p>
          I like to work with Vue.js, CSS, ES6, Sketch, GLSL Shaders, THREEjs and GSAP.
        </p>
        <p>
          Creative Technologist at BBVA Mexico.
        </p>

        <h3>Get in touch: </h3>
        <p class="social-links">
          <a href="mailto:erz440@gmail.com">erz440@gmail.com</a> 
          <a :href="require('@/assets/resume_Heri.pdf')" download> download resume</a>
          <a href="https://www.linkedin.com/in/heri-rodriguez-387a2535/">Linkedin</a>
          <a href="https://github.com/soybisonte">Github</a>
          <a href="https://codepen.io/soybisonte">Codepen</a>
          <span>(+52) 844 449 2909</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { TimelineMax, TweenMax, Power3 } from 'gsap';
import { map, toDegrees } from '@/scripts/utils/math'
import isMobile from 'ismobilejs';
export default {
  name: 'Profile',
  components: {
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  beforeDestroy() {
  },
  methods: {
    mouseOver() {
    },
    mouseLeave() {
    },
  },
};
</script>
<style src="../styles/views/Profile.styl" lang="stylus"></style>
